import { push, replace } from '@/utils/history';
import qs from 'qs';
import { useMemo } from 'react';
import { useHistory, useLocation, useParams, useRouteMatch } from 'react-router-dom';

const useRouter = <Params>() => {
  const params = useParams();
  const location = useLocation();
  const history = useHistory();
  const match = useRouteMatch<Params>();

  return useMemo(() => {
    return {
      push,
      replace,
      pathname: location.pathname,
      query: {
        ...qs.parse(location.search.slice(1)), // 去掉问号
        ...params,
      } as Record<string, string>,
      match,
      location,
      history,
    };
  }, [params, match, location, history]);
};

export default useRouter;
